import { useState } from 'react';
import { login } from '../api.js';

/**
 * アクセスコードの入力。
 * コード自体は localStorage へ保存しない(端末を共有される可能性があるため)。
 * 認証状態は HttpOnly Cookie がサーバー側で保持する。
 */
export function Login({ onSuccess }: { onSuccess: () => void }): JSX.Element {
  const [code, setCode] = useState('');
  const [error, setError] = useState<string>();
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (event: React.FormEvent): Promise<void> => {
    event.preventDefault();
    setBusy(true);
    setError(undefined);
    try {
      await login(code);
      onSuccess();
    } catch (e: unknown) {
      setError(e instanceof Error ? e.message : 'ログインできませんでした。');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="screen">
      <h1 className="app-title">CIXING リアルタイム通訳</h1>
      <p className="app-subtitle">アクセスコードを入力してください</p>

      {error && <div className="notice error">{error}</div>}

      <form onSubmit={(e) => void handleSubmit(e)}>
        <div className="field">
          <label htmlFor="access-code">アクセスコード</label>
          <input
            id="access-code"
            type="password"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            autoComplete="off"
            autoCapitalize="off"
            autoCorrect="off"
            placeholder="配布されたコード"
          />
        </div>
        <button className="primary start-button" type="submit" disabled={busy || code === ''}>
          {busy ? '確認しています…' : 'ログイン'}
        </button>
      </form>
    </div>
  );
}
